import { computed, type StyleValue } from 'vue';

const useMessagesListBackButton = () => {
  const backButtonStyles = computed<StyleValue>(() => ({
    bottom: '100px',
    marginLeft: '-50px',
    zIndex: 1000,
  }));

  return { backButtonStyles };
};

export { useMessagesListBackButton };
